export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00186.7cd3df10.png";